<template>
  <div class="rootGrid">
    <div class="showLabeGrid">
      <span>{{firstCategory.name+"-"+secondCategory.name}}</span>
    </div>
    <div class="dropDownGrid">
      <div class="menuGrid">
        <div class="firstMenu">
          <ul>
            <li
              v-for="(item,index) in category"
              :key="index"
              :class="{activeStyle:index==firstCategoryKey}"
              @click="selectedFirstCategory(item);firstCategoryKey=index"
            >
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
        <div class="secondMenu">
          <ul>
            <li
              v-for="(item,index) in firstCategory.data"
              :key="index"
              :class="{activeStyle:index==secondCategoryKey}"
              @click="selectedSecondCategory(item);secondCategoryKey=index"
            >
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "templateCategoryPicker",
  data() {
    return {
      firstCategory: {},
      secondCategory: {},
      firstCategoryKey: "",
      secondCategoryKey: ""
    };
  },
  props: {
    category: {}
  },
  components: {},
  methods: {
    selectedFirstCategory(item) {
      this.firstCategory = item;
    },
    selectedSecondCategory(item) {
      this.secondCategory = item;
      this.$emit("changedCategory", item);
    }
  },
  watch: {
    category: function(val, oldval) {
      if (val.length > 0) {
        for (const key in val) {
          this.firstCategoryKey = key;
          this.firstCategory = val[key];
          break;
        }
      }
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.rootGrid {
  position: relative;
  width: 200px;
  height: 38px;
  z-index: 101;

  &:hover {
    .dropDownGrid {
      display: flex;
    }
  }

  .showLabeGrid {
    > span {
      display: inline-block;
      width: 100%;
      font-size: 14;
      color: #6565ff;
      text-align: left;
      line-height: 38px;
    }
  }
  .dropDownGrid {
    display: flex;
    width: 200px;
    height: 184px;
  }
  .menuGrid {
    display: flex;
    flex-wrap: nowrap;
    justify-content: start;
    width: 200px;
    height: 184px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 4px 0px rgba(71, 66, 97, 0.4);
    overflow: hidden;

    .firstMenu {
      width: 88px;
      height: 100%;
      background: #f0f0f8;

      > ul {
        > li {
          height: 32px;
          width: 87px;
          font-size: 14px;
          color: #474261;
          border-left: 2px solid #f0f0f8;

          > span {
            line-height: 32px;
          }
        }
      }
      .activeStyle {
        border-color: #6565ff;
        color: #6565ff;
        background-color: #fff;
      }
    }
    .secondMenu {
      width: 112px;
      height: 100%;
      overflow: hidden;
      > ul {
        height: 100%;
        width: 135px;
        overflow-y: scroll;
        > li {
          height: 32px;
          font-size: 14px;
          color: #474261;
          background-color: #fff;
          > span {
            line-height: 32px;
          }
        }
      }
      .activeStyle {
        color: #6565ff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/rightnav/controls/templateCategoryPicker.vue